import { useAtomValue } from 'jotai'
import React from 'react'

import { buildNineSegmentsCustomerAttributesArrayData } from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import {
  type Brand,
  useSurveyQueryCustomerAttributeGroups,
} from '~/hooks/useSurveyQuery'

import { nineSegmentSortFunctionAtom, tabulationQueryDataAtom } from '../atoms'

import { useGetNineSegmentsData } from './useGetNineSegmentsData'

export const useNineSegmentsCustomerAttributesArrayData = (brand: Brand) => {
  const customerAttributeGroups = useSurveyQueryCustomerAttributeGroups()

  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)

  const getNineSegmentsData = useGetNineSegmentsData(brand)
  const sort = useAtomValue(nineSegmentSortFunctionAtom)

  return React.useMemo(
    () =>
      buildNineSegmentsCustomerAttributesArrayData({
        brandNumber: brand.number,
        customerAttributeGroups,
        customerAttributeResults: tabulationQueryData?.customerAttributes ?? [],
        getNineSegmentsData,
        sort,
      }),
    [
      brand.number,
      customerAttributeGroups,
      getNineSegmentsData,
      sort,
      tabulationQueryData?.customerAttributes,
    ],
  )
}
